/**
 * BuilderScreen — the AI Integration Builder surface: header + (mapping table |
 * right panel) body.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { colors } from '../../theme';
import { useBuilder } from './useBuilder';
import BuilderHeader from './BuilderHeader';
import MappingTable from './MappingTable';
import RightPanel from './RightPanel';

export default function BuilderScreen() {
  const b = useBuilder();
  return (
    <View style={styles.root}>
      <BuilderHeader />
      <View style={styles.body}>
        <MappingTable />
        <RightPanel adapterId={b.adapter.id} vendorName={b.vendorName} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: colors.paper } as any,
  body: { flex: 1, flexDirection: 'row', overflow: 'hidden' } as any,
});
